import React from 'react';

export const CaretDown = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12' fill='none'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.43756 4.09522C9.74998 4.40763 9.74998 4.91417 9.43756 5.22659L6.70703 7.95711C6.31651 8.34764 5.68334 8.34764 5.29282 7.95711L2.56229 5.22659C2.24987 4.91417 2.24987 4.40763 2.56229 4.09522C2.87471 3.7828 3.38124 3.7828 3.69366 4.09522L5.99993 6.40148L8.30619 4.09522C8.61861 3.7828 9.12514 3.7828 9.43756 4.09522Z'
      fill='currentColor'
    />
  </svg>
);

//  对号
export const CheckIcon = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='16' height='17' viewBox='0 0 16 17' fill='none'>
    <path
      d='M3 8.29412L6.13043 12L12 5'
      stroke='var(--col_brand00)'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export const CloseIcon = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
    <path
      d='M2.81458 2.81467C3.07493 2.55432 3.49704 2.55432 3.75738 2.81467L13.1855 12.2428C13.4458 12.5031 13.4458 12.9252 13.1855 13.1856C12.9251 13.4459 12.503 13.4459 12.2427 13.1856L2.81458 3.75748C2.55423 3.49713 2.55423 3.07502 2.81458 2.81467Z'
      fill='currentColor'
    />
    <path
      d='M13.1855 2.81424C13.4458 3.07459 13.4458 3.4967 13.1855 3.75705L3.75736 13.1851C3.49701 13.4455 3.0749 13.4455 2.81455 13.1851C2.55421 12.9248 2.55421 12.5027 2.81456 12.2423L12.2426 2.81424C12.503 2.55389 12.9251 2.55389 13.1855 2.81424Z'
      fill='currentColor'
    />
  </svg>
);
export const TipCloseIcon = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12' fill='none'>
    <path
      d='M3 2.5L6 5.5M9 8.5L6 5.5M6 5.5L9 2.5M6 5.5L3 8.5'
      stroke='var(--col_text02)'
      strokeWidth='1.74'
      strokeLinecap='round'
    />
  </svg>
);
